<script setup>
import { useRouter } from 'vue-router';
import { useRoute } from 'vue-router';

import ToolSetList from './ToolSetList.vue';

defineProps({
  bot: {
    type: Object,
    default: () => ({}),
  },
});

const router = useRouter();
const route = useRoute();

const selectTool = (toolSet, tool) => {
  router.replace({
    name: 'wgpt_bots_edit_tool',
    params: {
      ...route.params,
      toolSetId: toolSet.id,
      toolId: tool.id,
    },
    query: {
      selected: 'settings',
    },
  });
};
</script>

<template>
  <ToolSetList :bot="bot" @select-tool="selectTool" />
</template>
